<template>
    <div class="labels_section">
        <i class="uis uis-tag"></i>
        <h2>Labels</h2>
        <h2>This section is under construction</h2>
    </div>
</template>

<script>
export default {

}
</script>

<style>
.labels_section {
    padding-top: 2rem;

    i {
        font-size: 2rem;
    }
}
</style>